/**
 * Statuses a Studio AI job can hold while it is still being generated.
 *
 * Sora reports `queued` → `preprocessing` → `running` → `succeeded`, and our
 * own records add `pending` and `processing`. Every one of them means "not
 * finished yet", so every one of them has to keep the status monitor running:
 * the backend learns that a video finished only when something asks it (the
 * status endpoint or the status WebSocket), so a job the UI stops asking about
 * stays "running" until someone clicks Refresh status.
 */
const ACTIVE_MEDIA_STATUSES: ReadonlySet<string> = new Set([
  "pending",
  "queued",
  "preprocessing",
  "processing",
  "running",
])

/** True while a job is still being generated (any non-terminal status). */
export function isActiveMediaStatus(status: string | null | undefined): boolean {
  return typeof status === "string" && ACTIVE_MEDIA_STATUSES.has(status)
}
